import React from 'react';
import { Route, Routes as RoutesContainer } from 'react-router';

import { HangerListPage } from './pages/HangerListPage';
import { LumberListPage } from './pages/LumberListPage';
import { LumberSetPage } from './pages/LumberSetPage';
import { MainPage } from './pages/MainPage';
import { PlateDesignValuesPage } from './pages/PlateGripDesignValuesPage';
import { PlateListPage } from './pages/PlateListPage';

export function Routes() {
  return (
    <RoutesContainer>
      <Route path="/" element={<MainPage />} />
      <Route path="/plateGrip" element={<PlateDesignValuesPage />} />
      <Route path="/lumberLists/:lumberListGuid" element={<LumberListPage />} />
      <Route path="/lumberLists/:lumberListGuid/lumberSets/:lumberSetGuid/edit" element={<LumberSetPage />} />
      <Route path="/plateLists/:plateListGuid" element={<PlateListPage />} />
      <Route path="/hangerLists/:hangerListGuid" element={<HangerListPage />} />
    </RoutesContainer>
  );
}
